var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Deferred } from './deferred';
export function exponentialBackoffScheduler(options) {
    var _this = this;
    var _a = options.delayInterval, delayInterval = _a === void 0 ? 100 : _a, _b = options.exponent, exponent = _b === void 0 ? 2 : _b, _c = options.maxRetries, maxRetries = _c === void 0 ? 10 : _c;
    return function (task) {
        var resultDeferred = new Deferred();
        var attemptNumber = 1;
        var cancelled = false;
        var stopped = false;
        var timeout;
        var scheduleAttempt = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, task((function (value) {
                                stopped = true;
                                resultDeferred.resolve({ status: 'completed', value: value });
                            }), function (noEarlierThan) {
                                if (attemptNumber <= maxRetries) {
                                    var delay = Math.floor(Math.random() *
                                        Math.pow(exponent, attemptNumber) *
                                        delayInterval);
                                    attemptNumber += 1;
                                    timeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                        var error_2;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, noEarlierThan];
                                                case 1:
                                                    _a.sent();
                                                    scheduleAttempt();
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    error_2 = _a.sent();
                                                    handleError(error_2);
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); }, delay);
                                }
                                else {
                                    stopped = true;
                                    resultDeferred.resolve({ status: 'abandoned' });
                                }
                            }, attemptNumber)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (cancelled) {
                            console.warn('Ignoring error that occurred after cancellation:', error_1);
                        }
                        else {
                            handleError(error_1);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var handleError = function (error) {
            stopped = true;
            if (timeout) {
                clearTimeout(timeout);
            }
            resultDeferred.reject(error);
        };
        var cancel = function () {
            if (!stopped) {
                cancelled = true;
                stopped = true;
                resultDeferred.resolve({ status: 'cancelled' });
                if (timeout) {
                    clearTimeout(timeout);
                }
            }
        };
        scheduleAttempt();
        return {
            cancel: cancel,
            result: resultDeferred.promise,
        };
    };
}
//# sourceMappingURL=asyncTaskSchedulers.js.map